import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toFixedDollar'
})
export class ToFixedDollarPipe implements PipeTransform {

  transform(value: any): unknown {
    return value ? "$" + value.toFixed(2) : "$0.00";
  }

}
